import React from 'react'

interface TikTokProps {
  className?: string
}

const TikTok: React.FC<TikTokProps> = ({ className }: TikTokProps) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1222_3116)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0336 1.25H9.96644C8.59472 1.25 7.51929 1.24999 6.65494 1.32061C5.77479 1.39252 5.04769 1.54138 4.38955 1.87671C3.30762 2.42798 2.42798 3.30762 1.87671 4.38955C1.54138 5.04768 1.39252 5.77479 1.32061 6.65494C1.24999 7.51929 1.25 8.59472 1.25 9.96644V14.0336C1.25 15.4053 1.24999 16.4807 1.32061 17.3451C1.39252 18.2252 1.54138 18.9523 1.87671 19.6104C2.42798 20.6924 3.30762 21.572 4.38956 22.1233C5.04768 22.4586 5.77479 22.6075 6.65494 22.6794C7.51925 22.75 8.59468 22.75 9.96632 22.75H9.96637H14.0336H14.0337C15.4053 22.75 16.4808 22.75 17.3451 22.6794C18.2252 22.6075 18.9523 22.4586 19.6104 22.1233C20.6924 21.572 21.572 20.6924 22.1233 19.6104C22.4586 18.9523 22.6075 18.2252 22.6794 17.3451C22.75 16.4808 22.75 15.4053 22.75 14.0337V14.0336V9.96637V9.96632C22.75 8.59469 22.75 7.51925 22.6794 6.65494C22.6075 5.77479 22.4586 5.04768 22.1233 4.38956C21.572 3.30762 20.6924 2.42798 19.6104 1.87671C18.9523 1.54138 18.2252 1.39252 17.3451 1.32061C16.4807 1.24999 15.4053 1.25 14.0336 1.25ZM17.9392 10.3975C18.0571 10.397 18.175 10.391 18.2924 10.3796H18.2944V7.98898C17.3977 7.92343 16.5526 7.54477 15.9069 6.91922C15.2611 6.29367 14.8558 5.46103 14.7618 4.56689H12.7039L12.6824 14.5972C12.6824 15.8278 11.5956 16.7973 10.365 16.7973C9.77416 16.7973 9.20751 16.5626 8.78971 16.1448C8.37192 15.727 8.1372 15.1604 8.1372 14.5695C8.1372 13.9787 8.37192 13.412 8.78971 12.9942C9.20751 12.5764 9.77416 12.3417 10.365 12.3417C10.4335 12.3417 10.4998 12.3508 10.5661 12.3598C10.589 12.363 10.6118 12.3661 10.6348 12.3688V10.2178C10.6135 10.2165 10.5923 10.215 10.571 10.2135C10.5028 10.2088 10.4345 10.204 10.365 10.204C9.5017 10.204 8.65777 10.46 7.93994 10.9396C7.22212 11.4193 6.66265 12.101 6.33227 12.8986C6.00189 13.6962 5.91545 14.5738 6.08387 15.4206C6.2523 16.2673 6.66803 17.0451 7.27848 17.6555C7.88894 18.266 8.66671 18.6817 9.51344 18.8501C10.3602 19.0186 11.2378 18.9321 12.0354 18.6017C12.833 18.2714 13.5148 17.7119 13.9944 16.9941C14.474 16.2762 14.73 15.4323 14.73 14.569V8.66316C15.0789 9.19596 15.5549 9.6335 16.1152 9.93629C16.6755 10.2391 17.3023 10.3976 17.9392 10.3975Z"
        fill="#252324"
      />
    </g>
    <defs>
      <clipPath id="clip0_1222_3116">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default TikTok
